import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { API } from "../config/api-config";

declare var alertify: any;
declare var $: any;
@Component({
  templateUrl: "./challengeMission.html",
})
export class ChallengeMission implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpService
  ) {}

  private imagePath: string = "";
  private data: any = [];
  private taskId: any = [];
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.taskId = Number(params["id"]);
    });
    this.getPath();
    this.getData();
  }
  private getData() {
    this.http.getData(API.getFiveGoal + "/" + this.taskId).then((res) => {
      this.data = res.data;
      this.data.dataList = [];
      if (JSON.stringify(this.data.fiveGoalAttendActivitiesDto) != "{}") {
        this.data.fiveGoalAttendActivitiesDto.icon =
          this.imagePath + this.data.fiveGoalAttendActivitiesDto.icon;
        this.data.dataList.push(this.data.fiveGoalAttendActivitiesDto);
      }
      if (JSON.stringify(this.data.fiveGoalDreamDto) != "{}") {
        this.data.fiveGoalDreamDto.icon =
          this.imagePath + this.data.fiveGoalDreamDto.icon;
        this.data.dataList.push(this.data.fiveGoalDreamDto);
      }
      if (JSON.stringify(this.data.fiveGoalInvitationDto) != "{}") {
        this.data.fiveGoalInvitationDto.icon =
          this.imagePath + this.data.fiveGoalInvitationDto.icon;
        this.data.dataList.push(this.data.fiveGoalInvitationDto);
      }
      if (JSON.stringify(this.data.fiveGoalRostersDto) != "{}") {
        this.data.fiveGoalRostersDto.icon =
          this.imagePath + this.data.fiveGoalRostersDto.icon;
        this.data.dataList.push(this.data.fiveGoalRostersDto);
      }
      if (JSON.stringify(this.data.fiveGoalTargetSettingDto) != "{}") {
        this.data.fiveGoalTargetSettingDto.icon =
          this.imagePath + this.data.fiveGoalTargetSettingDto.icon;
        this.data.dataList.push(this.data.fiveGoalTargetSettingDto);
      }
      console.log(this.data.dataList);
    });
  }
  private getPath(): void {
    this.http.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      this.getData();
    });
  }

  private editProduct(id: number, type: string) {
    this.router.navigate(["index/challengeMissionEdit", this.taskId, id, type]);
  }
  //
  private deleteProduct(id: number, type: string): void {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.http
          .deleteData(API.deleteFiveGoalTask + "/" + type + "/" + id)
          .then((res) => {
            if (res.status.code == 0) {
              alertify.success(res.status.message);
              _self.getData();
            } else {
              alertify.error(res.status.message);
            }
          });
      },
      function () {}
    );
  }

  private exportData(type: number): void {
    let _self = this;
    let html = `
    <div class="form-group">
      <label>Type</label>
      <select
        class="form-control"
        name="type"
      >
        <option value="1">已完成</option>
        <option value="2">未完成</option>
      </select>
    </div>
    <div class="form-group">
      <label>Start date</label>
      <input type="date" class="form-control" name="startDate" />
        
    </div>
    <div class="form-group">
      <label>End date</label>
      <input type="date" class="form-control" name="endDate" />
        
    </div>
    `;
    alertify.confirm(
      html,
      function () {
        let enddate = $('input[name="endDate"]').val();
        let startdate = $('input[name="startDate"]').val();
        let outType = $('select[name="type"]').val();
        _self.http.download(API.exportFiveGoal, {
          enddate,
          startdate,
          outType,
          taskType: type,
        });
      },
      function () {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/task/challengeMission.component.ts